import { useRef, useState, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Horizontal side-scrolling row with snap + arrow controls.
export const HScroll = ({ children, testid = "hscroll" }) => {
  const ref = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 2);
    setAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 2);
  }, []);

  useEffect(() => {
    update();
    const el = ref.current;
    if (!el) return;
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [update]);

  const scrollBy = (dir) => {
    const el = ref.current;
    if (!el) return;
    const amount = Math.min(el.clientWidth * 0.85, 720);
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <div className="relative">
      <div
        ref={ref}
        data-testid={testid}
        className="flex gap-6 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-2 -mx-1 px-1"
      >
        {children}
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          data-testid={`${testid}-prev`}
          onClick={() => scrollBy(-1)}
          disabled={atStart}
          aria-label="Scroll left"
          className="w-12 h-12 rounded-full border border-[#0A221C]/15 flex items-center justify-center text-[#0A221C] hover:bg-[#0A221C] hover:text-white transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-[#0A221C] disabled:cursor-not-allowed"
        >
          <ChevronLeft size={20} />
        </button>
        <button
          data-testid={`${testid}-next`}
          onClick={() => scrollBy(1)}
          disabled={atEnd}
          aria-label="Scroll right"
          className="w-12 h-12 rounded-full border border-[#0A221C]/15 flex items-center justify-center text-[#0A221C] hover:bg-[#0A221C] hover:text-white transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-[#0A221C] disabled:cursor-not-allowed"
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
};
